export default "__VITE_ASSET__BBOltsz___"